import {
  getNotGroupOperator,
  isNotExclusionGroup,
} from 'src/utils/misc';

/** Normalize API `NOT` blocks to UI shape for preview rendering. */
export const normalizeQueryItemForPreview = (queryItem) => {
  if (queryItem?.type !== 'block') {
    return queryItem;
  }

  if (isNotExclusionGroup(queryItem.operator) && queryItem.operator !== 'NOT') {
    return queryItem;
  }

  if (queryItem.operator !== 'NOT' || !queryItem.argument) {
    return queryItem;
  }

  const inner = queryItem.argument;
  if (inner?.type !== 'block') {
    return {
      ...queryItem,
      operator: 'NOT (AND)',
      arguments_list: [inner],
    };
  }

  const items = inner.arguments_list || [];
  const keepGrouped = items.length > 1 || items[0]?.type === 'block';
  const operator = inner.operator === 'OR' ? 'NOT (OR)' : 'NOT (AND)';

  return {
    ...queryItem,
    operator,
    arguments_list: keepGrouped ? [inner] : items,
  };
};

export const getNotExclusionChildOperator = (operator) =>
  `${getNotGroupOperator(operator)} NOT`;

export { isNotExclusionGroup };
